module.exports = __webpack_public_path__ + "media/packs/images/flags/MW-8b809d1da551daf7efb6bb8cc182f606.svg";